module.exports = __webpack_public_path__ + "img/spree.6398cf3a.png";